import axios, { InternalAxiosRequestConfig } from 'axios';
import { config } from '../config';

const api = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token and restaurant ID to requests
api.interceptors.request.use((requestConfig: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('authToken');
  const selectedRestaurantId = localStorage.getItem('selectedRestaurantId');
  
  if (token && requestConfig.headers) {
    requestConfig.headers.Authorization = `Bearer ${token}`;
  }
  
  if (selectedRestaurantId && requestConfig.headers) {
    requestConfig.headers['X-Restaurant-Id'] = selectedRestaurantId;
  }
  
  return requestConfig;
});

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Detectar erros de CORS ou Network Error
    const isCorsError = !error.response || 
                       error.message === 'Network Error' || 
                       error.message?.includes('CORS') ||
                       error.code === 'ERR_NETWORK';
    
    if (isCorsError) {
      // Erro de CORS - deslogar e redirecionar
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      localStorage.removeItem('subscriptionBlocked');
      localStorage.removeItem('subscriptionBlockMessage');
      localStorage.removeItem('selectedRestaurantId');
      localStorage.removeItem('restaurants');
      window.location.href = '/';
      return Promise.reject(error);
    }
    
    if (error.response?.status === 401) {
      // Token inválido ou expirado - deslogar e redirecionar
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      localStorage.removeItem('subscriptionBlocked');
      localStorage.removeItem('subscriptionBlockMessage');
      localStorage.removeItem('selectedRestaurantId');
      localStorage.removeItem('restaurants');
      window.location.href = '/';
    }
    
    if (error.response?.status === 403) {
      // Sistema bloqueado por subscription
      const message = error.response?.data?.message || 'Sistema bloqueado';
      localStorage.setItem('subscriptionBlocked', 'true');
      localStorage.setItem('subscriptionBlockMessage', message);
      
      // Disparar evento customizado para atualizar o contexto
      window.dispatchEvent(new CustomEvent('subscriptionBlocked', { detail: { message } }));
    }
    
    return Promise.reject(error);
  }
);

export default api;

